import getTheme from '../selectors/getTheme';
import { getIsDarkTheme } from 'owa-fabric-theme';

export function getThemeIdFromParameter(themeId?: string) {
    return themeId === void 0 ? getTheme() : themeId;
}

export function getIsDarkThemeFromParameter(isDarkTheme?: boolean) {
    return isDarkTheme === void 0 ? getIsDarkTheme() : isDarkTheme;
}
